import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import styles from "./Charts.module.css";

ChartJS.register(ArcElement, Tooltip, Legend);

interface DonutChartProps {
  title: string;
  data: Array<{ label: string; value: number; percentage: number }>;
  centerText?: string;
  centerValue?: string | number;
  colors?: string[];
}

const DonutChart: React.FC<DonutChartProps> = ({
  title,
  data,
  centerText,
  centerValue,
  colors = ["#1E3A5F", "#52B981", "#F13C4F"],
}) => {
  const chartData = {
    labels: data.map((d) => d.label),
    datasets: [
      {
        data: data.map((d) => d.value),
        backgroundColor: colors,
        borderWidth: 0,
        cutout: "70%",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context: any) {
            const label = context.label || "";
            const value = context.parsed || 0;
            const percentage =
              data[context.dataIndex]?.percentage?.toFixed(1) || 0;
            return `${label}: ${value} (${percentage}%)`;
          },
        },
      },
    },
  };

  return (
    <div className={styles.chartContainer}>
      <h3 className={styles.chartTitle}>{title}</h3>
      <div className={styles.donutWrapper}>
        <div className={styles.donutChart}>
          <Doughnut data={chartData} options={options} />
          {centerText && (
            <div className={styles.donutCenter}>
              <div className={styles.donutCenterLabel}>{centerText}</div>
              <div className={styles.donutCenterValue}>{centerValue}</div>
            </div>
          )}
        </div>
        <div className={styles.donutLegend}>
          {data.map((item, index) => (
            <div key={index} className={styles.legendItem}>
              <div
                className={styles.legendColor}
                style={{ backgroundColor: colors[index % colors.length] }}
              />
              <div className={styles.legendText}>
                <span className={styles.legendLabel}>{item.label}</span>
                <span className={styles.legendValue}>{item.value}</span>
                <span className={styles.legendPercentage}>
                  {item.percentage.toFixed(1)}%
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DonutChart;
